var whatsappRelativePath = '/whatsapp';
var settingsWhatsappRelativePath = '/settings/whatsapp';
export var createWhatsappApi = function (baseUrl, http) {
    var whatsappApiUrl = baseUrl + whatsappRelativePath;
    var whatsappTemplatesApiUrl = baseUrl + settingsWhatsappRelativePath;
    return {
        addAgentReply: function (whatsappDto) { return http.post("".concat(whatsappApiUrl, "/message"), whatsappDto); },
        getTemplates: function (dto) {
            return http.get("".concat(whatsappTemplatesApiUrl, "/templates?locale=").concat(dto.locale));
        },
    };
};
//# sourceMappingURL=index.js.map